// src/utils/exportTextWithSplits.js
export function exportToTxtSplits(elementId, filename = 'export-splits.txt', delimiter = '\t', headerLines = []) {
   const root = document.getElementById(elementId);
  if (!root) {
    console.warn(`Element s ID "${elementId}" nebyl nalezen.`);
    return;
  }

  const lines = [];
  const hdr = Array.isArray(headerLines) ? headerLines : [];
  const hdrClean = hdr.map(x => (x == null ? '' : String(x).trim())).filter(Boolean);
  if (hdrClean.length) {
    lines.push(...hdrClean);
    lines.push('');
  }
  const tables = Array.from(root.querySelectorAll('table'));
  if (!tables.length) {
    console.warn('Nenalezena tabulka s výsledky.');
    return;
  }

  tables.forEach(table => {
    // Nadpis kategorie (např. "M20 (1)")
    const section = table.closest('.v-col');
    const titleEl = section && section.querySelector('.v-card-title');
    if (titleEl) lines.push(titleEl.innerText.trim());

    // Řádky tabulky
    Array.from(table.querySelectorAll('tbody tr')).forEach(tr => {
      const c1 = pickCell(tr, 1); // place
      const c2 = pickCell(tr, 2); // jméno
      const c3 = pickCell(tr, 3); // index
      const c4 = pickCell(tr, 4); // run_time
      const c5 = pickCell(tr, 5); // punch_count

      const codeSplits = extractCodeSplitsFromRow(tr); // ["(1) 5:30", "(2) 5:10", ..., "(F) 0:20"]
      const line = formatRowWithSplits([c1, c2, c3, c4, c5], codeSplits, delimiter);
      lines.push(line);
    });

    lines.push(''); // prázdný řádek mezi sekcemi
  });

  // stažení souboru
  const content = lines.join('\n');
  const bytes = encodeWindows1250(content);
  const blob = new Blob([bytes], { type: 'text/plain;charset=windows-1250' });
  const url  = URL.createObjectURL(blob);
  const a    = Object.assign(document.createElement('a'), { href: url, download: filename });
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** Bezpečně vrátí text z konkrétní TD (1-based). */
function pickCell(tr, index) {
  const td = tr.querySelector(`td:nth-child(${index})`);
  return td ? (td.textContent || '').replace(/\r?\n+/g, ' ').trim() : '';
}

/**
 * Z 7. sloupce vytáhne dvojice (KÓD, split_time) ve formátu "(<code>) <time>".
 * Ignoruje kumulativní čas (je ve druhém vnitřním <div>).
 */
function extractCodeSplitsFromRow(tr) {
  // Struktura: td:nth-child(7) > div.d-flex > div (blok) >
  //   div:first-child  => "<b>CODE</b> <split_time>"
  //   div:last-child   => cumulative_time (ignorujeme)
  const nodes = Array.from(
    tr.querySelectorAll('td:nth-child(7) > div > div > div:first-child')
  );

  return nodes.map(line => {
    const code = (line.querySelector('b')?.textContent || '').trim();

    // Textový uzel hned za <b> je split_time
    let split = '';
    for (const n of line.childNodes) {
      if (n.nodeType === Node.TEXT_NODE) {
        const t = n.textContent.trim();
        if (t) { split = t; break; }
      }
    }
    // Fallback: první výskyt m:ss / mm:ss / mmm:ss
    if (!split) {
      const m = (line.textContent || '').match(/\b\d{1,3}:\d{2}\b/);
      split = m ? m[0] : '';
    }

    return (code && split) ? `(${code}) ${split}` : '';
  }).filter(Boolean);
}

/**
 * Zarovnání 3. sloupce na pevnou pozici (32 znaků) + extra \t před run_time a punch_count.
 * Na konec přidá " - "-spojený seznam "(<code>) <time>".
 */
function formatRowWithSplits([c1, c2, c3, c4, c5], splits, delimiter) {
  const firstPart = `${c1}${delimiter}${c2}`;
  const padded = firstPart.padEnd(32, ' '); // 3. sloupec začne na stejné pozici
  const base =
    `${padded}` +
    `${delimiter}${c3}` +
    `${delimiter}${delimiter}${c4}` +
    `${delimiter}${c5}`;
  return splits && splits.length ? `${base}${delimiter}${splits.join(' - ')}` : base;
}

// Stejný encoder jako v exportTxt.js (Windows-1250)
function encodeWindows1250(str) {
  const map = {
    '€': 0x80, '‚': 0x82, '„': 0x84, '…': 0x85, '†': 0x86, '‡': 0x87, '‰': 0x89,
    'Š': 0x8A, '‹': 0x8B, 'Ś': 0x8C, 'Ť': 0x8D, 'Ž': 0x8E, 'Ź': 0x8F,
    '‘': 0x91, '’': 0x92, '“': 0x93, '”': 0x94, '•': 0x95, '–': 0x96, '—': 0x97, '™': 0x99,
    'š': 0x9A, '›': 0x9B, 'ś': 0x9C, 'ť': 0x9D, 'ž': 0x9E, 'ź': 0x9F,
    ' ': 0xA0, 'ˇ': 0xA1, '˘': 0xA2, 'Ł': 0xA3, '¤': 0xA4, 'Ą': 0xA5, '¦': 0xA6, '§': 0xA7,
    '¨': 0xA8, '©': 0xA9, 'Ş': 0xAA, '«': 0xAB, '¬': 0xAC, '­': 0xAD, '®': 0xAE, 'Ż': 0xAF,
    '°': 0xB0, '±': 0xB1, '˛': 0xB2, 'ł': 0xB3, '´': 0xB4, 'ą': 0xB5, '¸': 0xB8,
    'ş': 0xBA, '»': 0xBB, 'Ľ': 0xBC, '˝': 0xBD, 'ľ': 0xBE, 'ż': 0xBF,
    'Ŕ': 0xC0, 'Á': 0xC1, 'Â': 0xC2, 'Ă': 0xC3, 'Ä': 0xC4, 'Ĺ': 0xC5, 'Ć': 0xC6, 'Ç': 0xC7,
    'Č': 0xC8, 'É': 0xC9, 'Ę': 0xCA, 'Ë': 0xCB, 'Ě': 0xCC, 'Í': 0xCD, 'Î': 0xCE, 'Ď': 0xCF,
    'Đ': 0xD0, 'Ń': 0xD1, 'Ň': 0xD2, 'Ó': 0xD3, 'Ô': 0xD4, 'Ő': 0xD5, 'Ö': 0xD6, '×': 0xD7,
    'Ř': 0xD8, 'Ú': 0xD9, 'Ű': 0xDA, 'Ü': 0xDB, 'Ý': 0xDD, 'Ţ': 0xDE, 'ß': 0xDF,
    'ŕ': 0xE0, 'á': 0xE1, 'â': 0xE2, 'ă': 0xE3, 'ä': 0xE4, 'ĺ': 0xE5, 'ć': 0xE6, 'ç': 0xE7,
    'č': 0xE8, 'é': 0xE9, 'ę': 0xEA, 'ë': 0xEB, 'ě': 0xEC, 'í': 0xED, 'î': 0xEE, 'ď': 0xEF,
    'đ': 0xF0, 'ń': 0xF1, 'ň': 0xF2, 'ó': 0xF3, 'ô': 0xF4, 'ő': 0xF5, 'ö': 0xF6, '÷': 0xF7,
    'ř': 0xF8, 'ú': 0xFA, 'ű': 0xFB, 'ü': 0xFC, 'ý': 0xFD, 'ţ': 0xFE,
  };

  const out = new Uint8Array(str.length);
  for (let i = 0; i < str.length; i++) {
    const ch = str[i];
    const code = ch.codePointAt(0);
    if (code <= 0x7F) out[i] = code;
    else if (Object.prototype.hasOwnProperty.call(map, ch)) out[i] = map[ch];
    else out[i] = 0x3F;
  }
  return out;
}